import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "outOf", "decimalPlaces", "hideValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';
import Text from 'components/Text';
import VisuallyHidden from 'components/VisuallyHidden';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getReadableTrend(t, trendKey, readableLabel, hideValue) {
  if (!hideValue || trendKey === 'neutral') {
    return t("analytics_trend_".concat(trendKey), {
      percent: readableLabel
    });
  }
  return t("analytics_trend_".concat(trendKey, "_no_value"));
}
function getTrendKey(value) {
  if (value > 0) return 'positive';else if (value < 0) return 'negative';else return 'neutral';
}
function getIconName(trendKey) {
  if (trendKey === 'negative') return 'nav-down';else if (trendKey === 'positive') return 'nav-up';else return 'dot';
}
function TrendIndicator(props) {
  var value = props.value,
    _props$outOf = props.outOf,
    outOf = _props$outOf === void 0 ? 100 : _props$outOf,
    _props$decimalPlaces = props.decimalPlaces,
    decimalPlaces = _props$decimalPlaces === void 0 ? 0 : _props$decimalPlaces,
    _props$hideValue = props.hideValue,
    hideValue = _props$hideValue === void 0 ? false : _props$hideValue,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var trendKey = getTrendKey(value);
  var suffix = outOf === 100 ? '%' : '';
  var readableLabel = "".concat(Math.abs(value).toFixed(decimalPlaces)).concat(suffix);
  var isNeutral = trendKey === 'neutral';
  return /*#__PURE__*/_jsxs(Text, _objectSpread(_objectSpread({
    display: "inline-block",
    dimmed: isNeutral,
    textColor: isNeutral ? undefined : trendKey
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(Icon, {
      "aria-hidden": "true",
      name: getIconName(trendKey),
      scale: 0.8
    }), !hideValue && /*#__PURE__*/_jsx("span", {
      "aria-hidden": "true",
      children: readableLabel
    }), /*#__PURE__*/_jsx(VisuallyHidden, {
      children: getReadableTrend(t, trendKey, readableLabel, hideValue)
    })]
  }));
}
export default TrendIndicator;